import { Box } from "@mui/material";
import { Title } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import StudentRecordDetails from "./StudentRecordDetails";
import StudentRecordDisciplines from "./StudentRecordDisciplines";
import StudentRecordContinuingDisciplines from "./StudentRecordContinuingDisciplines";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const StudentRecord = () => {
  const { id } = useParams();
  const notifyError = useNotifyError();
  const [studentRecordDetails, setStudentRecordDetails] = useState(null);
  const educationId = studentRecordDetails?.studentEducationId;

  const studentName = studentRecordDetails?.secondName
    ? `${studentRecordDetails?.firstName} ${studentRecordDetails?.secondName} ${studentRecordDetails?.lastName}`
    : `${studentRecordDetails?.firstName} ${studentRecordDetails?.lastName}`;

  useEffect(() => {
    if (!id) return;
    const fetchDetails = async () => {
      try {
        const { data } = await dataProvider.customRequest(studentRequests.getStudentRecordDetails(id), null, "GET");
        setStudentRecordDetails(data);
      } catch (err) {
        notifyError(err);
      }
    };
    fetchDetails();
  }, [id, notifyError]);

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <Title title={"Студентски картон "} />
      <BackButtonToolbar />
      {studentRecordDetails && (
        <>
          <StudentRecordDetails
            studentRecordDetails={studentRecordDetails}
            studentName={studentName}
          />
          <StudentRecordDisciplines
            studentName={studentName}
            educationId={educationId}
          />
          <StudentRecordContinuingDisciplines />
        </>
      )}
    </Box>
  );
};

export default StudentRecord;
